<template>
 
  <div class="w-full mb-6">
    <div
      class="bg-white h-full w-full flex justify-around items-center rounded-lg flex-col pt-10"
    >
      <p class="text-[18px] font-semibold">{{ campaign.name }}</p>
      <div class="w-full">
        <div
          class="bg-[#EEEEEE] bg-opacity-40 w-full p-2 py-4 flex justify-between px-8"
        >
          <p class="text-[16px] font-bold">Campaign Status</p>
          <div class="flex items-center">
            <!-- <img src="../../../assets/SVGs/Pending.svg" v-if="
                  !campaign.is_approved &&
                    !campaign.is_expired ||
                  (campaign.is_approved &&
                    !campaign.is_active && !campaign.is_expired)
                "> -->
            <svg
              v-if="
                (!campaign.is_approved && !campaign.is_expired) ||
                (campaign.is_approved &&
                  !campaign.is_active &&
                  !campaign.is_expired)
              "
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
            >
              <g id="Waiting" transform="translate(-524 -272)">
                <circle
                  id="Ellipse_1224"
                  data-name="Ellipse 1224"
                  cx="13"
                  cy="13"
                  r="13"
                  transform="translate(524 272)"
                  fill="none"
                />
                <g
                  id="Group_16555"
                  data-name="Group 16555"
                  transform="translate(529 277)"
                >
                  <circle
                    id="Ellipse_1222"
                    data-name="Ellipse 1222"
                    cx="8"
                    cy="8"
                    r="8"
                    fill="#ffbe00"
                  />
                  <path
                    id="time-oclock"
                    d="M5.567,0a5.567,5.567,0,1,0,5.567,5.567A5.567,5.567,0,0,0,5.567,0Zm0,10.206a4.639,4.639,0,1,1,4.639-4.639A4.639,4.639,0,0,1,5.567,10.206Zm.928-4.639a.928.928,0,1,1-1.392-.8V3.247a.464.464,0,1,1,.928,0v1.52a.925.925,0,0,1,.464.8Z"
                    transform="translate(2.433 2.433)"
                    fill="#fff"
                  />
                </g>
              </g>
            </svg>
            <!-- <img src="../../../assets/SVGs/Expired.svg" v-if="campaign.is_expired "> -->
            <svg
              v-if="campaign.is_expired"
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
            >
              <g
                id="Expired_at_"
                data-name="Expired at "
                transform="translate(-124 -684)"
              >
                <circle
                  id="Ellipse_1224"
                  data-name="Ellipse 1224"
                  cx="13"
                  cy="13"
                  r="13"
                  transform="translate(124 684)"
                  fill="none"
                />
                <g id="cross-circle" transform="translate(129.6 689.6)">
                  <path
                    id="Path_25685"
                    data-name="Path 25685"
                    d="M7.4,0a7.4,7.4,0,1,0,7.4,7.4A7.4,7.4,0,0,0,7.4,0ZM9.867,9a.617.617,0,1,1-.835.907Q9.013,9.885,9,9.867L7.4,8.272,5.805,9.867a.617.617,0,0,1-.872-.872L6.528,7.4,4.933,5.805a.617.617,0,0,1,.872-.872L7.4,6.528,9,4.933a.617.617,0,0,1,.907.835q-.017.019-.036.036L8.272,7.4Z"
                    transform="translate(0)"
                    fill="#bf3939"
                  />
                </g>
              </g>
            </svg>
            <!-- <img src="../../../assets/SVGs/Active.svg" v-if="campaign.is_active"> -->
            <svg
              v-if="campaign.is_active"
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
            >
              <g id="Active" transform="translate(-97 -295)">
                <circle
                  id="Ellipse_1224"
                  data-name="Ellipse 1224"
                  cx="13"
                  cy="13"
                  r="13"
                  transform="translate(97 295)"
                  fill="none"
                />
                <g
                  id="active_icon"
                  data-name="active icon"
                  transform="translate(102 299.78)"
                >
                  <circle
                    id="Ellipse_1206"
                    data-name="Ellipse 1206"
                    cx="8"
                    cy="8"
                    r="8"
                    transform="translate(0 0.22)"
                    fill="#369DA3"
                  />
                  <path
                    id="shield-check_1_"
                    data-name="shield-check (1)"
                    d="M14.216,8.532l-3.4,3.4a1.489,1.489,0,0,1-1.061.44H9.732a1.488,1.488,0,0,1-1.069-.477L6.829,9.983a.8.8,0,1,1,1.146-1.1l1.784,1.86,3.33-3.339A.8.8,0,1,1,14.213,8.53Z"
                    transform="translate(-2.377 -1.685)"
                    fill="#fff"
                  />
                </g>
              </g>
            </svg>
            <p
              class="text-[12px] font-semibold"
              :class="[
                campaign.is_active ? 'text-black' : '',
                campaign.is_expired ? 'text-red-600' : '',
                !campaign.is_approved && !campaign.is_expired
                  ? 'text-secondary'
                  : '',
                campaign.is_approved ? 'text-black' : '',
              ]"
            >
              {{ campaign.is_active ? "Active " : "" }}
              {{
                !campaign.is_approved && !campaign.is_expired
                  ? "Pending Approval"
                  : ""
              }}
              {{
                campaign.is_approved &&
                !campaign.is_active &&
                !campaign.is_expired
                  ? " Approved"
                  : ""
              }}
              {{ campaign.is_expired ? "Expired " : "" }}
              <br />
            </p>
          </div>
        </div>
      </div>
      <div class="w-full px-8">
        <div class="w-full p-2 flex justify-between">
          <p class="text-[14px] font-medium text-[#AEAEAE]">Campaign Type:</p>
          <div class="flex items-center gap-1">
            <p class="text-[14px] font-semibold">
              {{
                campaign.advertising_goal == null
                  ? "Awareness"
                  : campaign.advertising_goal
              }}
            </p>
          </div>
        </div>
        <hr class="h-1 w-[100%]" />
        <div class="w-full p-2 flex justify-between">
          <p class="text-[14px] font-medium text-[#AEAEAE]">Ad Loop:</p>
          <div class="flex items-center gap-1">
            <p class="text-[14px] font-semibold">{{ ad_loops }}</p>
          </div>
        </div>
        <hr class="h-1 w-[100%]" />
        <div class="w-full p-2 flex justify-between">
          <p class="text-[14px] font-medium text-[#AEAEAE]">Impressions:</p>
          <div class="flex items-center gap-1">
            <p class="text-[14px] font-semibold">{{ impressions }}</p>
          </div>
        </div>
        <hr class="h-1 w-[100%]" />
        <div class="w-full p-2 flex justify-between">
          <p class="text-[14px] font-medium text-[#AEAEAE]">
            Target Locations:
          </p>
          <div class="flex items-center gap-1">
            <p class="text-[14px] font-semibold">
              {{ campaign.zone_count }} Location(s)
            </p>
          </div>
        </div>
        <hr class="h-1 w-[100%]" />
        <div class="w-full p-2 flex justify-between">
          <p class="text-[14px] font-medium text-[#AEAEAE]">Start Date:</p>
          <div class="flex items-center gap-1">
            <p class="text-[14px] font-semibold">{{ campaign.starts_at }}</p>
          </div>
        </div>
        <hr class="h-1 w-[100%]" />
        <div class="w-full p-2 flex justify-between">
          <p class="text-[14px] font-medium text-[#AEAEAE]">End Date:</p>
          <div class="flex items-center gap-1">
            <p class="text-[14px] font-semibold">{{ campaign.ends_at }}</p>
          </div>
        </div>
        <hr class="h-1 w-[100%]" />
        <div class="w-full p-2 flex justify-between">
          <p class="text-[14px] font-medium text-[#AEAEAE]">Budget:</p>
          <div class="flex items-center gap-1">
            <p class="text-[14px] font-semibold">
              {{ campaign.budget.toLocaleString() }} {{ currency }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    campaign: {},
  },
  data() {
    return {
      currency: null,
    };
  },
  mounted() {
    this.currency = this.getCenterCoordinates();
  },

  computed: {
    impressions() {
      if (!this.campaign.budget) {
        return "-";
      }
      // let cost = 0.09;
      // let val = this.campaign.budget / cost;
      // let min = Math.round((val * 0.75) / 1e3);
      // let max = Math.round((val * 1.25) / 1e3);
      // return `${min}k ~ ${max}k`;
      if (localStorage.getItem("country_code") === "EG") {
        let cost = 0.09;
        let val = this.campaign.budget / cost;
        let min = Math.round((val * 0.75) / 1e3);
        let max = Math.round((val * 1.25) / 1e3);
        return `${min}k ~ ${max}k`;
      } else if (localStorage.getItem("country_code") == "sa") {
        let cost = 0.01125;
        let val = this.campaign.budget / cost;
        let min = Math.round((val * 0.75) / 1e3);
        let max = Math.round((val * 1.25) / 1e3);
        return `${min}k ~ ${max}k`;
      }
    },

    ad_loops() {
      if (!this.campaign.budget) {
        return "-";
      }
      // let cost = 0.65;
      // let val = this.campaign.budget / cost;
      // let min = Math.round((val * 0.75) / 1e3);
      // let max = Math.round((val * 1.25) / 1e3);
      // return `${min}k ~ ${max}k`;
      if (localStorage.getItem("country_code") === "EG") {
        let cost = 0.65;
        let val = this.campaign.budget / cost;
        let min = Math.round((val * 0.75) / 1e3);
        let max = Math.round((val * 1.25) / 1e3);
        return `${min}k ~ ${max}k`;
      } else if (localStorage.getItem("country_code") == "sa") {
        let cost = 0.08125;
        let val = this.campaign.budget / cost;
        let min = Math.round((val * 0.75) / 1e3);
        let max = Math.round((val * 1.25) / 1e3);
        return `${min}k ~ ${max}k`;
      }
    },
  },

  methods: {
    getCenterCoordinates() {
      const country = localStorage.getItem("country_code");

      let currency = this.currency;

      if (country === "EG") {
        currency = "EGP"; // cairo currency
      } else if (country == "SA") {
        currency = "SAR"; //riydh currency
      }

      return currency;
    },
  },
};
</script>

<style></style>
